import {
  BebyggelseobjektUtkastBildPost,
  BebyggelseobjektUtkastBildPostRequest,
  BebyggelseobjektUtkastBildPut,
  BebyggelseobjektUtkastBildPutRequest,
  GranskningResurs
} from 'models';

import { bebyggelseApiRTK } from 'api/bebyggelseApiRTK';
import dayjs from 'dayjs';

const UTKAST_URL = `bebyggelseobjekt/utkast`;

const toPutOrPostFormData = (bildRequest: BebyggelseobjektUtkastBildPut | BebyggelseobjektUtkastBildPost) => {
  const formData = new FormData();
  formData.append('bildfil', bildRequest.bildfil || '');
  formData.append('titel', bildRequest.titel);
  formData.append('bildtext', bildRequest.bildtext);
  formData.append('vy', bildRequest.vy);
  formData.append('licens', bildRequest.licens.toString());
  formData.append('tillkomstdatum', dayjs(bildRequest.tillkomstdatum).format('YYYY-MM-DD'));
  formData.append('upphovsman_fornamn', bildRequest.upphovsmanFornamn || '');
  formData.append('upphovsman_efternamn', bildRequest.upphovsmanEfternamn || '');

  return formData;
};

export const dokumentationBildSlice = bebyggelseApiRTK.injectEndpoints({
  endpoints: (build) => ({
    putBild: build.mutation<GranskningResurs, BebyggelseobjektUtkastBildPutRequest>({
      query: ({ bildPut, utkastId, resursId }) => ({
        url: `${UTKAST_URL}/${utkastId}/dokumentation/bild/${resursId}`,
        method: 'PUT',
        headers: {
          Accept: 'application/json'
        },
        body: toPutOrPostFormData(bildPut)
      })
    }),
    postBild: build.mutation<GranskningResurs, BebyggelseobjektUtkastBildPostRequest>({
      query: ({ bildPost, utkastId }) => ({
        url: `${UTKAST_URL}/${utkastId}/dokumentation/bild`,
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: toPutOrPostFormData(bildPost)
      })
    })
  })
});

export const { usePutBildMutation, usePostBildMutation } = dokumentationBildSlice;
